import { object, string, array, number, type InferType } from "yup";
import { format as jFormat } from "date-fns-jalali";

const roomSchema = object({
  adult: number().required().default(2),
  child: array(string().required("سن کودک الزامی است")) // Require non-nullable strings
    .optional() // Make the child field optional
    .default([]), // Default to empty array
});

export const hotelSchema = object({
  checkin: string().required("تاریخ رفت الزامی می باشد"),
  checkout: string().required("تاریخ برگشت الزامی می باشد"),
  city: object({
    name: string(),
    id: string(),
    code: string(),
  })
    .default(undefined)
    .required("مقصد الزامی می باشد"),
  rooms: array(roomSchema)
    .required()
    .default([{ adult: 2, child: [] }]),
}).required();

export const hotelDefaultValue = {
  checkin: jFormat(new Date(), "yyyy/MM/dd"),
  checkout: jFormat(
    new Date(new Date().getTime() + 24 * 60 * 60 * 1000), // 1 day later
    "yyyy/MM/dd",
  ),
  city: {
    id: undefined,
    code: "MHD",
    name: "مشهد",
  },
  rooms: [{ adult: 2, child: [] }],
};

export type HotelSchema = InferType<typeof hotelSchema>;
